import classNames from 'classnames';
import { AnimatePresence, m as motion } from 'framer-motion';
import DeleteSVG from 'public/icons/bin.svg';
import DownloadSVG from 'public/icons/download.svg';
import PdfSVG from 'public/icons/pdf.svg';
import ReactDOM from 'react-dom';
import { TransformedCard } from '@/shared/api/lib/utils/transform-program';
import { createPdf } from '@/shared/api/postFavouritesPrograms';
import { useFavoriteWindowStateValue } from '@/shared/atoms/favorite-window';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Button from '../Button';

interface Props {
    favorites: TransformedCard[];
    setFavorites: React.Dispatch<React.SetStateAction<number[]>>;
}

function FavoriteWindowContent({ favorites, setFavorites }: Props) {
    const isShow = useFavoriteWindowStateValue();
    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');

    return (
        <AnimatePresence>
            {favorites.length > 0 && isShow && (
                <motion.div
                    exit={{ opacity: 0, y: 100, x: isMobile ? 0 : '-50%' }}
                    initial={{ opacity: 0, y: 100, x: isMobile ? 0 : '-50%' }}
                    animate={{ opacity: 1, y: 0, x: isMobile ? 0 : '-50%' }}
                    className="favorite-window"
                >
                    <div className="favorite-window-top">
                        <div className="favorite-window-count text-xs">
                            {isMobile ? 'Кол-во избранного:' : 'Количество избранного:  '} {favorites.length}
                        </div>
                        <button
                            className="favorite-window-delete-btn"
                            onClick={() => {
                                if (favorites.length > 0) {
                                    setFavorites([]);
                                }
                            }}
                        >
                            <div className="favorite-window-delete-btn-text text-xs">Удалить все</div>
                            <DeleteSVG />
                        </button>
                    </div>
                    <Button
                        className={classNames('favorite-window-download-btn js-favorite-window-download-btn')}
                        onClick={() => {
                            createPdf(favorites, 'Избранное - Программа TNF');
                        }}
                    >
                        <div className="presentation-btn-left">
                            <PdfSVG className="pdf-svg" />
                            <div className="text-xs">Сохранить избранное</div>
                        </div>
                        <div className="download-loader-wrapper">
                            <div className="download-loader"></div>
                        </div>
                        <DownloadSVG className="download-svg" />
                        <div className="presentation-btn-error text-xs">Что то пошло не так</div>
                    </Button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

function FavoriteWindow({ favorites, setFavorites }: Props) {
    const portalRoot = typeof window !== 'undefined' ? document.querySelector('#modal-root') : null;

    if (!portalRoot) {
        return null;
    }

    return ReactDOM.createPortal(
        <FavoriteWindowContent favorites={favorites} setFavorites={setFavorites} />,
        portalRoot,
    );
}

export default FavoriteWindow;
